module.exports = __webpack_public_path__ + "static/media/confirmed_inactive.63f11564.svg";